(ns app.strive-forms.logic-jumps-logic
  (:require
   [clojure.string :refer [blank? ends-with? lower-case starts-with?]]))

(defn check-operation? [{:keys [operation comparison_value]} value]
  (case operation
    "is_empty" (blank? value)
    "is_not_empty" (not (blank? value))
    "equals" (if (or (vector? value) (list? value))
               (and (some? comparison_value) (> (.indexOf value comparison_value) -1))
               (and (some? comparison_value) (some? value) (= (lower-case value) (lower-case comparison_value))))

    "not_equals"
    (if (and (some? value) (list? value))
      (and (some? value) (some? comparison_value) (= (.indexOf value comparison_value) -1))
      (and (some? value) (some? comparison_value) (not= (lower-case value) (lower-case comparison_value))))

    "begins_with" (and (some? value) (some? comparison_value) (starts-with? value comparison_value))

    "ends_with" (and (some? value) (some? comparison_value) (ends-with? value comparison_value))

    "contains" (and (some? value) (some? comparison_value) (contains? value comparison_value))

    "not_contains" (and (some? value) (some? comparison_value) (not (contains? value comparison_value)))

    "greater_than" (and  (some? value) (some? comparison_value)  (> value comparison_value))

    "greater_than_or_equal" (and  (some? value) (some? comparison_value)  (>= value comparison_value))

    "less_than" (and  (some? value) (some? comparison_value)  (< value comparison_value))

    "less_than_or_equal" (and  (some? value) (some? comparison_value)  (<= value comparison_value))))

(defn compare-rule-with-join-operation [[first-subrule-boolean & rest-subrules-boolean] sub_rules_join_operations]
  (->> rest-subrules-boolean
       (interleave sub_rules_join_operations)
       (partition 2)
       (reduce (fn [res [op bool]]
                 (if (= "or" op)
                   (or res bool)
                   (and res bool)))
               first-subrule-boolean)))

(defn hidden-field? [sub-rule]
  (= (:type (:field sub-rule)) "hidden"))

(defn hidden-field-value [hidden-fields sub-rule]
  (get hidden-fields (keyword (lower-case (:field_name (:field sub-rule))))))

(defn apply-rule [{:keys [sub_rules sub_rules_join_operations]} value hidden-fields] 
  (-> (map (fn [sub-rule]
             (check-operation? sub-rule (if (hidden-field? sub-rule)
                                          (hidden-field-value hidden-fields sub-rule)
                                          value)))
           sub_rules)
      (compare-rule-with-join-operation sub_rules_join_operations)))

(defn apply-rules [rules value hidden-fields]
  (first (for [rule rules
               :when (apply-rule rule value hidden-fields)]
           (:jump_to_field_id rule))))

(defn get-jump-to-field-id [rules hidden-fields value]
  (or (apply-rules (:rules rules) value hidden-fields) (:default_jump rules)))

(defn check-logic-flow [rules id hidden-fields value]
  (when (or (and (some? (:rules rules)) (some? (not-empty (:rules rules)))) (some? (:default_jump rules)))
    (get-jump-to-field-id rules hidden-fields value)))

(defn field-in-right-position? [result form-field]
  (or (nil?  (:jump-to-field-id (last result)))
      (= (int  (:jump-to-field-id (last result))) (int (:id form-field)))))

(defn add-field-to-display-array [{:keys [id] :as form-field} logic-flows form-data value]
  (assoc form-field
         :jump-to-field-id (check-logic-flow (get logic-flows (keyword id))
                                             id
                                             (:form-filling/hidden-fields form-data)
                                             (:value (get value (keyword id))))))

(defn default-jump-to-field-id [result]
  {:jump-to-field-id (:jump-to-field-id (last result))})

(defn create-form-fields [jump-to-field-id form-fields logic-flows form-data value] 
  (->> form-fields
       (reduce-kv
        (fn [result _ form-field]
          (conj result (if (field-in-right-position? result form-field)
                         (add-field-to-display-array form-field logic-flows form-data value)
                         (default-jump-to-field-id result))))
        [{:jump-to-field-id jump-to-field-id}])
       (filterv :id)))